import MenuNames from "../../../constants/Menu/MenuNames.json";
import Slots from "../../../views/Slots";
import SlotsBulkUploadDailyCapacity from "../../../views/SlotsBulkUploadDailyCapacity";
import DriverSlotsExemption from "../../../views/DriverSlotsExemption";
import SlotsInfo from "../../../views/SlotsInfo";
import SlotDetails from "../../../views/SlotDetails";
import DriverStarGigsExemption from "../../../views/DriverStarGigsExemption";
import GigsBulkOptOut from "../../../views/GigsBulkOptOut";
import SlotsCancellationFeeExemption from "../../../views/SlotsCancellationFeeExemption";
import DriverSlotsCancellationFeeExemption from "../../../views/DriverSlotsCancellationFeeExemption";
import GigsBulkOptIn from "../../../views/GigsBulkOptIn";
import GigsCapacityChange from "../../../views/GigsCapacityChange";

const SlotsRoutes = [
  {
    menuName: MenuNames.SLOT_CAPACITY_UPDATE,
    path: "/slot-capacity-update",
    component: Slots,
    exact: true,
  },
  {
    menuName: MenuNames.SLOT_CAPACITY_UPDATE,
    path: "/slot-capacity-attendance-exemption",
    component: SlotsBulkUploadDailyCapacity,
    exact: true,
  },
  {
    menuName: MenuNames.SLOT_CAPACITY_UPDATE,
    path: "/driver-slots-attendance-exemption",
    component: DriverSlotsExemption,
    exact: true,
  },
  {
    menuName: MenuNames.SLOT_CAPACITY_UPDATE,
    path: "/driver-star-gigs-exemption",
    component: DriverStarGigsExemption,
    exact: true,
  },
  {
    menuName: MenuNames.SLOT_CAPACITY_UPDATE,
    path: "/bulk-gigs-opt-out",
    component: GigsBulkOptOut,
    exact: true,
  },
  {
    menuName: MenuNames.SLOT_CAPACITY_UPDATE,
    path: "/bulk-gigs-opt-in",
    component: GigsBulkOptIn,
    exact: true,
  },
  {
    menuName: MenuNames.SLOT_CAPACITY_UPDATE,
    path: "/gigs-cancellation-fee-exemption",
    component: SlotsCancellationFeeExemption,
    exact: true,
  },
  {
    menuName: MenuNames.SLOT_CAPACITY_UPDATE,
    path: "/driver-gigs-cancellation-fee-exemption",
    component: DriverSlotsCancellationFeeExemption,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_SLOT_VIEW_DETAILS,
    path: "/slots-details",
    component: SlotsInfo,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_SLOT_VIEW_DETAILS,
    path: "/slots-details/:id(\\d+)",
    component: SlotDetails,
    exact: true,
  },
  {
    menuName: MenuNames.MANUAL_SLOT_CAPACITY_UPDATE,
    path: "/gigs-capacity-change",
    component: GigsCapacityChange,
    exact: true,
  },
];

export default SlotsRoutes;
